module.exports = __webpack_public_path__ + "static/21c44514-f4d6-4cff-a5de-e4cac5e61aff-472cf49b518e8ab502ac93a75fd187ea.woff2";